import { render, staticRenderFns } from "./Dadospessoais.vue?vue&type=template&id=160fff0a"
import script from "./Dadospessoais.vue?vue&type=script&lang=js"
export * from "./Dadospessoais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports